export default () => (
  <svg width="500" height="276" viewBox="0 0 500 276" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_10845_102428)">
      <path
        d={`M254.867 109.51L288.674 72.1515H304.591C306.038 72.1515 307.551 71.1649 308.537
        70.1125C309.392 69.1917 310.116 68.0078 310.708 65.377L350.829 110.365H255.591L254.867 109.51Z`}
        fill="#EEEEEE"
      />
      <path
        d={`M235.464 221.718H121.547C118.653 221.718 116.285 219.35 116.285 216.456V115.43C116.285
        114.114 116.811 112.799 117.666 111.878L174.033 51.1046C175.02 50.0523 176.467 49.3945
        177.914 49.3945C179.361 49.3945 180.808 50.0523 181.794 51.1046L236.714 111.812C237.569
        112.799 238.095 114.049 238.095 115.364V219.021C238.095 220.534 236.911 221.718 235.464
        221.718ZM177.914 54.6563L121.547 115.43V216.456H232.833V115.364L177.914 54.6563Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M252.565 117.271C251.842 117.271 251.118 117.008 250.592 116.416L194.751
        54.6563H178.045C176.598 54.6563 175.414 53.4724 175.414 52.0254C175.414 50.5784
        176.598 49.3945 178.045 49.3945H194.751C196.264 49.3945 197.645 50.0523 198.632
        51.1046L254.472 112.865C255.459 113.917 255.393 115.627 254.275 116.548C253.815
        117.074 253.157 117.271 252.565 117.271Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M374.704 221.718H235.201C233.754 221.718 232.57 220.534 232.57 219.087C232.57
        217.64 233.754 216.456 235.201 216.456H372.073V115.364L317.943 54.6563H302.947C301.5
        54.6563 300.316 53.4724 300.316 52.0254C300.316 50.5784 301.5 49.3945 302.947
        49.3945H317.943C319.455 49.3945 320.902 50.0523 321.889 51.1704L376.019 111.878C376.874
        112.865 377.335 114.114 377.335 115.364V219.021C377.335 220.534 376.151 221.718 374.704 221.718Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M248.421 112.601C247.764 112.601 247.172 112.338 246.646 111.878C245.593 110.891
        245.527 109.247 246.514 108.129L285.057 66.3634C286.043 65.3111 287.687 65.2453 288.806
        66.2319C289.858 67.2184 289.924 68.8628 288.937 69.9809L250.395 111.746C249.803 112.338
        249.145 112.601 248.421 112.601Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M360.958 117.272C360.234 117.272 359.511 117.009 358.984 116.417L303.012
        54.6565C301.697 53.9988 301.237 52.4203 301.894 51.1048C302.552 49.7894 304.13
        49.329 305.446 49.9867C306.038 50.2498 306.498 50.6444 306.959 51.1048L362.931
        112.865C363.917 113.917 363.852 115.627 362.733 116.548C362.207 117.074 361.615
        117.272 360.958 117.272Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M374.704 117.272H235.727C234.28 117.272 233.097 116.088 233.097 114.641C233.097
        113.194 234.28 112.01 235.727 112.01H374.704C376.151 112.01 377.335 113.194 377.335
        114.641C377.335 116.088 376.151 117.272 374.704 117.272Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M302.881 70.7705H210.537C209.813 70.7705 209.09 70.4416 208.564 69.9154L193.896
        53.8013C193.173 53.012 193.041 51.8939 193.436 50.9731C193.831 50.0523 194.817 49.3945
        195.869 49.3945H303.933C304.591 49.3945 305.183 49.5918 305.643 50.0523C306.696
        50.9731 310.116 54.3274 310.247 59.8523C310.313 64.3248 308.143 67.5476 306.761
        69.0604C305.775 70.1128 304.328 70.7705 302.881 70.7705ZM211.721 65.5087H302.881C303.736
        64.5879 305.117 62.6147 305.051 59.9181C304.985 57.4187 303.736 55.5771 302.881
        54.6563H201.855L211.721 65.5087Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M497.369 221.719H2.63089C1.1839 221.719 0 220.535 0 219.088C0 217.641 1.1839
        216.457 2.63089 216.457H497.369C498.816 216.457 500 217.641 500 219.088C500 220.535
        498.816 221.719 497.369 221.719Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M65.9695 169.691H137.595C139.042 169.691 140.226 168.507 140.226
        167.06V122.664C140.226 121.217 139.042 120.033 137.595 120.033H65.9695C59.3923
        120.033 54.1305 125.361 54.1305 131.872V157.852C54.1305 164.364 59.3923 169.691
        65.9695 169.691Z`}
        fill="#EEEEEE"
      />
      <path
        d={`M137.595 172.322H65.9694C58.011 172.322 51.4996 165.811 51.4996
        157.852V131.872C51.4996 123.914 58.011 117.402 65.9694 117.402H137.595C140.489
        117.402 142.857 119.77 142.857 122.664V167.06C142.857 169.954 140.489 172.322
        137.595 172.322ZM65.9694 122.598C60.905 122.598 56.7613 126.742 56.7613
        131.806V157.852C56.7613 162.917 60.905 167.06 65.9694 167.06H137.595V122.664H65.9694V122.598Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M148.514 275.255H62.6808C59.7869 275.255 57.4191 272.887 57.4191 269.993V251.051C57.4191
        249.604 58.603 248.42 60.05 248.42H148.514C151.407 248.42 153.775 250.788 153.775
        253.682V269.993C153.775 272.953 151.407 275.255 148.514 275.255ZM62.6808
        253.682V269.993H148.514V253.682H62.6808Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M143.909 253.55H60.05C58.603 253.55 57.4191 252.366 57.4191 250.919V238.094C57.4191
        235.2 59.7869 232.832 62.6808 232.832H141.344C144.238 232.832 146.606 235.2 146.606
        238.094V250.985C146.54 252.432 145.356 253.55 143.909 253.55ZM62.6808
        248.288H141.344V238.094H62.6808V248.288Z`}
        fill="#B2B2B2"
      />
      <path d="M68.6003 235.267H101.289L110.234 169.561H77.5454L68.6003 235.267Z" fill="#EEEEEE" />
      <path
        d={`M101.289 237.897H68.6003C67.811 237.897 67.0875 237.568 66.6271 236.976C66.101
        236.384 65.9036 235.661 66.0352 234.872L74.9802 169.165C75.1775 167.85 76.2956
        166.863 77.6111 166.863H110.3C111.089 166.863 111.813 167.192 112.273 167.784C112.799
        168.376 112.997 169.1 112.865 169.889L103.92 235.595C103.723 236.911 102.605 237.897
        101.289 237.897ZM71.6258 232.635H98.987L107.209 172.191H79.8473L71.6258 232.635Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M153.183 166.074H142.923C140.029 166.074 137.661 163.706 137.661
        160.812V128.781C137.661 125.887 140.029 123.52 142.923 123.52H153.183C156.077
        123.52 158.445 125.887 158.445 128.781V160.812C158.445 163.706 156.143 166.074
        153.183 166.074ZM142.923 128.847V160.878H153.183V128.847H142.923Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M176.204 163.312H158.577C155.683 163.312 153.315 160.944 153.315
        158.05V131.609C153.315 128.715 155.683 126.348 158.577 126.348H176.204C179.098
        126.348 181.465 128.715 181.465 131.609V158.05C181.465 160.944 179.098 163.312
        176.204 163.312ZM158.577 131.609V158.05H176.204V131.609H158.577Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M216.325 147.461H178.9C177.453 147.461 176.269 146.277 176.269 144.83C176.269
        143.383 177.453 142.199 178.9 142.199H216.325C217.772 142.199 218.956 143.383
        218.956 144.83C218.956 146.277 217.772 147.461 216.325 147.461Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M211.721 150.092C208.892 150.092 207.708 147.593 207.051 146.014C206.327
        147.593 205.143 150.092 202.381 150.092C199.553 150.092 198.369 147.593
        197.711 146.014C196.988 147.593 195.804 150.092 193.041 150.092C190.213
        150.092 189.029 147.593 188.371 146.014C187.648 147.593 186.464 150.092
        183.702 150.092C180.808 150.092 179.624 147.461 178.966 145.882C178.834
        145.554 178.571 145.027 178.44 144.764C177.256 144.501 176.401 143.449
        176.401 142.199C176.401 140.752 177.585 139.568 179.032 139.568C181.86
        139.568 183.044 142.068 183.702 143.646C184.425 142.068 185.609 139.568
        188.371 139.568C191.2 139.568 192.384 142.068 193.041 143.646C193.765
        142.068 194.949 139.568 197.711 139.568C200.539 139.568 201.723 142.068
        202.381 143.646C203.104 142.068 204.288 139.568 207.051 139.568C209.945
        139.568 211.129 142.199 211.786 143.778C211.918 144.107 212.181 144.633
        212.312 144.896C213.496 145.159 214.351 146.211 214.351 147.461C214.351
        148.908 213.168 150.092 211.721 150.092Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M112.47 147.723H94.7776C93.3306 147.723 92.1467 146.539 92.1467
        145.092C92.1467 143.645 93.3306 142.461 94.7776 142.461H112.47C113.917
        142.461 115.101 143.645 115.101 145.092C115.101 146.539 113.917 147.723 112.47 147.723Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M80.8339 137.002H70.3104C68.8634 137.002 67.6795 135.818 67.6795
        134.371C67.6795 132.924 68.8634 131.74 70.3104 131.74H80.8339C82.2809
        131.74 83.4648 132.924 83.4648 134.371C83.4648 135.818 82.2809 137.002 80.8339 137.002Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M80.8339 147.723H64.9171C63.4701 147.723 62.2862 146.539 62.2862 145.092C62.2862
        143.645 63.4701 142.461 64.9171 142.461H80.8339C82.2809 142.461 83.4648 143.645
        83.4648 145.092C83.4648 146.539 82.2809 147.723 80.8339 147.723Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M80.8339 158.971H70.3104C68.8634 158.971 67.6795 157.787 67.6795 156.34C67.6795
        154.893 68.8634 153.709 70.3104 153.709H80.8339C82.2809 153.709 83.4648 154.893
        83.4648 156.34C83.4648 157.787 82.2809 158.971 80.8339 158.971Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M207.774 275.848H8.15573C6.70874 275.848 5.52484 274.664 5.52484 273.217C5.52484
        271.77 6.70874 270.586 8.15573 270.586H207.84C209.287 270.586 210.471 271.77 210.471
        273.217C210.471 274.664 209.287 275.848 207.774 275.848Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M181.071 62.5492L178.637 61.168C178.243 60.9049 177.716 60.9049 177.322 61.168L175.02
        62.4177C174.625 62.6808 174.362 63.0754 174.362 63.6016L174.428 66.2325C174.428 66.6929
        174.691 67.0875 175.085 67.3506L177.519 68.7318C177.914 68.9949 178.44 68.9949 178.835
        68.7318L181.137 67.4821C181.531 67.2191 181.794 66.8244 181.794 66.2983L181.728
        63.6674C181.728 63.207 181.465 62.8123 181.071 62.5492Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M334.122 112.337C337.016 112.403 339.976 112.469 342.87 112.469C344.12 112.469
        345.37 112.535 346.619 112.601C346.816 112.601 347.014 112.601 347.277 112.666C347.869
        112.469 348.527 112.403 349.119 112.272L365.298 67.9413L339.253 58.4043L319.587
        112.272C324.454 112.009 329.321 112.14 334.122 112.337Z`}
        fill="#EEEEEE"
      />
      <path
        d={`M322.415 112.207L340.831 61.8253L361.944 69.5207L346.225 112.601C346.356 112.601
        346.553 112.601 346.685 112.601C346.882 112.601 347.08 112.601 347.343 112.667C348.921
        112.273 350.5 112.075 352.013 112.141L368.719 66.3636L337.74 55.0508L316.759 112.536C318.6
        112.338 320.508 112.207 322.415 112.207Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M415.943 53.6696L415.877 53.4723C413.641 46.1058 409.366 39.4629 403.512 34.4642C403.446
        34.3984 403.446 34.3984 403.381 34.3326C397.198 29.0709 391.015 25.9796 386.477 24.1379L348.066
        10.1285C346.685 9.60229 345.172 10.3258 344.712 11.707L340.765 22.5594L330.373 18.7446L332.61
        12.6278C333.136 11.2466 332.412 9.73384 331.031 9.27343L313.141 2.76199C311.76 2.23581 310.247
        2.9593 309.787 4.34052L298.408 35.5823C297.882 36.9635 298.606 38.4763 299.987 38.9367L317.877
        45.4481C319.258 45.9743 320.771 45.2508 321.231 43.8696L323.467 37.7528L333.859 41.5676L329.979
        52.2227C329.453 53.6039 330.176 55.1166 331.557 55.577L367.469 68.6657C368.85 69.1919 370.363
        68.4684 370.823 67.0872L373.849 58.7999C374.441 57.1556 375.954 55.9717 377.664 55.7743C382.202
        55.2482 387.595 54.9851 393.581 55.5113C400.158 56.0374 405.946 57.2871 410.813 58.7999C413.97
        59.7864 416.864 56.8267 415.943 53.6696Z`}
        fill="#EEEEEE"
      />
      <path
        d={`M368.324 71.5601C367.732 71.5601 367.14 71.4286 366.548 71.2312L330.637 58.1426C329.321
        57.6822 328.269 56.6956 327.677 55.4459C327.085 54.1963 327.019 52.7493 327.48 51.4338L330.439
        43.2781L324.98 41.3049L323.665 44.9224C322.678 47.619 319.653 49.066 316.89 48.0794L299.066
        41.4365C296.369 40.4499 294.922 37.4244 295.909 34.6619L307.288 3.42014C307.748 2.1047 308.734
        1.05234 309.984 0.460395C311.234 -0.131555 312.681 -0.197327 313.996 0.263078L331.886
        6.77452C333.202 7.23493 334.254 8.22151 334.846 9.47118C335.438 10.7209 335.504 12.1678
        335.043 13.4833L333.728 17.1008L339.187 19.0739L342.213 10.7209C342.673 9.40541 343.66
        8.35306 344.909 7.76111C346.159 7.16916 347.606 7.10338 348.921 7.56379L387.398 21.7048C387.398
        21.7048 387.464 21.7048 387.464 21.7706C393.909 24.4015 399.763 27.9532 405.025 32.3599L405.157
        32.4914C411.339 37.7532 415.943 44.7908 418.311 52.7493L418.377 52.9466C419.1 55.3144 418.443
        57.8795 416.667 59.6553C414.891 61.4312 412.326 62.0889 409.958 61.3654C404.565 59.7211
        398.908 58.6688 393.318 58.2084C388.187 57.8137 383.057 57.8795 377.927 58.4714C377.138
        58.5372 376.546 59.0634 376.283 59.7869L373.257 68.0742C372.534 70.2447 370.495 71.5601
        368.324 71.5601ZM323.402 35.1881C323.731 35.1881 323.994 35.2539 324.323 35.3196L334.715
        39.1344C335.372 39.3975 335.898 39.8579 336.227 40.5156C336.556 41.1734 336.556 41.8969
        336.293 42.5546L332.412 53.2097L368.324 66.2983L371.35 58.011C372.27 55.3802 374.572 53.6043
        377.335 53.2754C382.794 52.6177 388.319 52.5519 393.778 53.0124C399.763 53.4728 405.748
        54.6567 411.536 56.3667C412.326 56.6298 412.852 56.1694 413.049 55.9721C413.246 55.7748
        413.641 55.2486 413.444 54.5251L413.378 54.3278C411.273 47.2902 407.261 41.1734 401.802
        36.5693L401.671 36.4378C396.869 32.3599 391.41 29.0713 385.556 26.7035L347.211 12.694L343.265
        23.5464C343.002 24.2041 342.541 24.7303 341.884 25.0592C341.226 25.3223 340.502 25.388 339.845
        25.125L329.453 21.3102C328.072 20.784 327.414 19.2712 327.874 17.9558L330.11 11.839L312.22
        5.26176L300.842 36.5035L318.732 43.015L320.968 36.8982C321.231 36.2405 321.692 35.7143 322.349
        35.3854C322.612 35.2539 323.007 35.1881 323.402 35.1881Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M323.007 41.4357C322.678 41.4357 322.415 41.37 322.086 41.3042C320.705 40.778 320.047
        39.2653 320.508 37.9498L328.203 16.9685C328.729 15.5873 330.242 14.9296 331.557 15.39C332.939
        15.9161 333.596 17.4289 333.136 18.7444L325.506 39.7257C325.112 40.778 324.125 41.4357 323.007 41.4357Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M333.465 45.2522C333.136 45.2522 332.873 45.1864 332.544 45.1206C331.163 44.5944
        330.505 43.0817 330.966 41.7662L338.595 20.7849C339.121 19.4037 340.634 18.746 341.95
        19.2064C343.331 19.7326 343.988 21.2453 343.528 22.5608L335.898 43.5421C335.504 44.5944
        334.517 45.2522 333.465 45.2522Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M339.384 85.2416C339.121 85.2416 338.792 85.1758 338.529 85.11C337.148 84.6496
        336.425 83.1369 336.951 81.7557L342.015 67.4831C342.476 66.1019 343.988 65.3784 345.37
        65.9046C346.751 66.365 347.474 67.8777 346.948 69.2589L341.884 83.5315C341.489 84.5839
        340.437 85.2416 339.384 85.2416Z`}
        fill="#B2B2B2"
      />
      <path
        d={`M342.673 112.47L349.053 92.9359C349.513 91.5547 348.724 90.0419 347.343 89.6473C345.962
        89.1869 344.449 89.9761 344.054 91.3574L337.148 112.47C338.99 112.47 340.831 112.47 342.673 112.47Z`}
        fill="#B2B2B2"
      />
    </g>
    <defs>
      <clipPath id="clip0_10845_102428">
        <rect width="500" height="275.848" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
